export default "__VITE_ASSET__CL3tAbFh__"